var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path, _path2, _path3, _path4, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPentHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Add_PentHouse",
    "data-name": "Add PentHouse",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6144",
    "data-name": "Rectangle 6144",
    width: 71.109,
    height: 5.781,
    transform: "translate(1.445 66.773)",
    fill: "#90d8ca"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6145",
    "data-name": "Rectangle 6145",
    width: 7.227,
    height: 5.781,
    transform: "translate(13.875 32.086)",
    fill: "#c8e7f9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6146",
    "data-name": "Rectangle 6146",
    width: 7.227,
    height: 5.781,
    transform: "translate(13.875 43.648)",
    fill: "#c8e7f9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6147",
    "data-name": "Rectangle 6147",
    width: 7.227,
    height: 5.781,
    transform: "translate(13.875 55.211)",
    fill: "#c8e7f9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6148",
    "data-name": "Rectangle 6148",
    width: 7.227,
    height: 5.781,
    transform: "translate(26.883 32.086)",
    fill: "#90d8ca"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6149",
    "data-name": "Rectangle 6149",
    width: 7.227,
    height: 5.781,
    transform: "translate(26.883 43.648)",
    fill: "#90d8ca"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6150",
    "data-name": "Rectangle 6150",
    width: 7.227,
    height: 5.781,
    transform: "translate(26.883 55.211)",
    fill: "#90d8ca"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6151",
    "data-name": "Rectangle 6151",
    width: 7.227,
    height: 5.781,
    transform: "translate(39.891 32.086)",
    fill: "#c8e7f9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6152",
    "data-name": "Rectangle 6152",
    width: 7.227,
    height: 5.781,
    transform: "translate(39.891 43.648)",
    fill: "#c8e7f9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6153",
    "data-name": "Rectangle 6153",
    width: 7.227,
    height: 5.781,
    transform: "translate(39.891 55.211)",
    fill: "#c8e7f9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6154",
    "data-name": "Rectangle 6154",
    width: 7.227,
    height: 5.781,
    transform: "translate(52.898 32.086)",
    fill: "#90d8ca"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6155",
    "data-name": "Rectangle 6155",
    width: 7.227,
    height: 5.781,
    transform: "translate(52.898 43.648)",
    fill: "#90d8ca"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6156",
    "data-name": "Rectangle 6156",
    width: 7.227,
    height: 5.781,
    transform: "translate(52.898 55.211)",
    fill: "#90d8ca"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6158",
    "data-name": "Rectangle 6158",
    width: 17.344,
    height: 5.781,
    transform: "translate(28.328 20.523)",
    fill: "#c8e7f9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6159",
    "data-name": "Rectangle 6159",
    width: 71.109,
    height: 13.297,
    transform: "translate(1.445 1.445)",
    fill: "#90d8ca"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M364.672,62h0A8.672,8.672,0,0,0,356,70.672v8.672h17.344V70.672A8.672,8.672,0,0,0,364.672,62Z",
    transform: "translate(-304.547 -53.039)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M44.672,62h0A8.672,8.672,0,0,0,36,70.672v8.672H53.344V70.672A8.672,8.672,0,0,0,44.672,62Z",
    transform: "translate(-30.797 -53.039)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M398.891,102A2.891,2.891,0,0,0,396,104.891v2.891h5.781v-2.891A2.891,2.891,0,0,0,398.891,102Z",
    transform: "translate(-338.766 -87.258)",
    fill: "#90d8ca"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M78.891,102A2.891,2.891,0,0,0,76,104.891v2.891h5.781v-2.891A2.891,2.891,0,0,0,78.891,102Z",
    transform: "translate(-65.016 -87.258)",
    fill: "#90d8ca"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62742",
    "data-name": "Group 62742"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M87.445,220.672h7.227a1.445,1.445,0,0,0,1.445-1.445v-5.781A1.445,1.445,0,0,0,94.672,212H87.445A1.445,1.445,0,0,0,86,213.445v5.781A1.445,1.445,0,0,0,87.445,220.672Zm1.445-5.781h4.336v2.891H88.891Z",
    transform: "translate(-73.57 -181.359)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M87.445,300.672h7.227a1.445,1.445,0,0,0,1.445-1.445v-5.781A1.445,1.445,0,0,0,94.672,292H87.445A1.445,1.445,0,0,0,86,293.445v5.781A1.445,1.445,0,0,0,87.445,300.672Zm1.445-5.781h4.336v2.891H88.891Z",
    transform: "translate(-73.57 -249.797)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M87.445,380.672h7.227a1.445,1.445,0,0,0,1.445-1.445v-5.781A1.445,1.445,0,0,0,94.672,372H87.445A1.445,1.445,0,0,0,86,373.445v5.781A1.445,1.445,0,0,0,87.445,380.672Zm1.445-5.781h4.336v2.891H88.891Z",
    transform: "translate(-73.57 -318.234)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M177.445,220.672h7.227a1.445,1.445,0,0,0,1.445-1.445v-5.781A1.445,1.445,0,0,0,184.672,212h-7.227A1.445,1.445,0,0,0,176,213.445v5.781A1.445,1.445,0,0,0,177.445,220.672Zm1.445-5.781h4.336v2.891h-4.336Z",
    transform: "translate(-150.563 -181.359)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M177.445,300.672h7.227a1.445,1.445,0,0,0,1.445-1.445v-5.781A1.445,1.445,0,0,0,184.672,292h-7.227A1.445,1.445,0,0,0,176,293.445v5.781A1.445,1.445,0,0,0,177.445,300.672Zm1.445-5.781h4.336v2.891h-4.336Z",
    transform: "translate(-150.563 -249.797)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M177.445,380.672h7.227a1.445,1.445,0,0,0,1.445-1.445v-5.781A1.445,1.445,0,0,0,184.672,372h-7.227A1.445,1.445,0,0,0,176,373.445v5.781A1.445,1.445,0,0,0,177.445,380.672Zm1.445-5.781h4.336v2.891h-4.336Z",
    transform: "translate(-150.563 -318.234)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M267.445,220.672h7.227a1.445,1.445,0,0,0,1.445-1.445v-5.781A1.445,1.445,0,0,0,274.672,212h-7.227A1.445,1.445,0,0,0,266,213.445v5.781A1.445,1.445,0,0,0,267.445,220.672Zm1.445-5.781h4.336v2.891h-4.336Z",
    transform: "translate(-227.555 -181.359)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M267.445,300.672h7.227a1.445,1.445,0,0,0,1.445-1.445v-5.781A1.445,1.445,0,0,0,274.672,292h-7.227A1.445,1.445,0,0,0,266,293.445v5.781A1.445,1.445,0,0,0,267.445,300.672Zm1.445-5.781h4.336v2.891h-4.336Z",
    transform: "translate(-227.555 -249.797)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M267.445,380.672h7.227a1.445,1.445,0,0,0,1.445-1.445v-5.781A1.445,1.445,0,0,0,274.672,372h-7.227A1.445,1.445,0,0,0,266,373.445v5.781A1.445,1.445,0,0,0,267.445,380.672Zm1.445-5.781h4.336v2.891h-4.336Z",
    transform: "translate(-227.555 -318.234)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M357.445,220.672h7.227a1.445,1.445,0,0,0,1.445-1.445v-5.781A1.445,1.445,0,0,0,364.672,212h-7.227A1.445,1.445,0,0,0,356,213.445v5.781A1.445,1.445,0,0,0,357.445,220.672Zm1.445-5.781h4.336v2.891h-4.336Z",
    transform: "translate(-304.547 -181.359)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M357.445,300.672h7.227a1.445,1.445,0,0,0,1.445-1.445v-5.781A1.445,1.445,0,0,0,364.672,292h-7.227A1.445,1.445,0,0,0,356,293.445v5.781A1.445,1.445,0,0,0,357.445,300.672Zm1.445-5.781h4.336v2.891h-4.336Z",
    transform: "translate(-304.547 -249.797)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M357.445,380.672h7.227a1.445,1.445,0,0,0,1.445-1.445v-5.781A1.445,1.445,0,0,0,364.672,372h-7.227A1.445,1.445,0,0,0,356,373.445v5.781A1.445,1.445,0,0,0,357.445,380.672Zm1.445-5.781h4.336v2.891h-4.336Z",
    transform: "translate(-304.547 -318.234)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M387.445,100.672h5.781a1.445,1.445,0,0,0,1.445-1.445V96.336a4.336,4.336,0,0,0-8.672,0v2.891A1.445,1.445,0,0,0,387.445,100.672Zm1.445-4.336a1.445,1.445,0,0,1,2.891,0v1.445h-2.891Z",
    transform: "translate(-330.211 -78.703)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M67.445,100.672h5.781a1.445,1.445,0,0,0,1.445-1.445V96.336a4.336,4.336,0,0,0-8.672,0v2.891A1.445,1.445,0,0,0,67.445,100.672Zm1.445-4.336a1.445,1.445,0,0,1,2.891,0v1.445H68.891Z",
    transform: "translate(-56.461 -78.703)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M74,14.742V1.445A1.445,1.445,0,0,0,72.555,0H1.445A1.445,1.445,0,0,0,0,1.445v13.3a1.445,1.445,0,0,0,1.445,1.445H3.863a10.144,10.144,0,0,0-.1,1.445v47.7H1.445A1.445,1.445,0,0,0,0,66.773v5.781A1.445,1.445,0,0,0,1.445,74H72.555A1.445,1.445,0,0,0,74,72.555V66.773a1.445,1.445,0,0,0-1.445-1.445H70.242v-47.7a10.143,10.143,0,0,0-.1-1.445h2.417A1.445,1.445,0,0,0,74,14.742ZM71.109,2.891V7.516H42.781a1.445,1.445,0,0,0,0,2.891H53.054A10.171,10.171,0,0,0,50.986,13.3H23.014a10.168,10.168,0,0,0-2.068-2.891H31.219a1.445,1.445,0,0,0,0-2.891H2.891V2.891ZM67.352,17.633v7.227H52.9V17.633a7.227,7.227,0,0,1,14.453,0ZM13.875,10.406A7.235,7.235,0,0,1,21.1,17.633v7.227H6.648V17.633A7.235,7.235,0,0,1,13.875,10.406ZM67.352,27.75V65.328H6.648V27.75Zm-21.68-8.672H28.328a1.445,1.445,0,0,0-1.445,1.445v4.336H23.992V16.188H50.008v8.672H47.117V20.523A1.445,1.445,0,0,0,45.672,19.078Zm-1.445,2.891v2.891H41.336V21.969Zm-5.781,0v2.891H35.555V21.969Zm-5.781,0v2.891H29.773V21.969ZM2.891,13.3V10.406H6.8A10.171,10.171,0,0,0,4.736,13.3ZM71.109,68.219v2.891H2.891V68.219ZM69.264,13.3A10.168,10.168,0,0,0,67.2,10.406h3.913V13.3Z",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M247.445,54.891A1.445,1.445,0,1,0,246,53.445,1.448,1.448,0,0,0,247.445,54.891Z",
    transform: "translate(-210.445 -44.484)",
    fill: "#0b5647"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPentHouse);
export default __webpack_public_path__ + "static/media/PentHouse.42935c9a209790a76c36daa68ccb5523.svg";
export { ForwardRef as ReactComponent };